// @ts-check
// @ts-ignore

import { openAction, closeAction, clearModal } from './action';
import KfModal from './kf-modal.riot';
export { KfModal };
export * from './action';
export { useModal, useModals, useEmbeddedModal } from './use-modal';
export * from './template';

// reducer 
export default (state = {}, action) => {
  switch (action.type) {
    case String(openAction): {
      const { name, props, size } = action.payload;
      return {
        ...state,
        [name]: {
          show: true,
          size,
          props,
        },
        stack: [...(state.stack ?? []), name],
      };
    }

    case String(closeAction): {
      const { name } = action.payload;
      return {
        ...state,
        [name]: {
          ...state[name],
          show: false,
          props: {},
        },
        stack: (state.stack ?? []).filter(modalName => modalName != name),
      };
    }

    case String(clearModal):
      return {};

    default:
      return state;
  }
};
